const CREATE_JOB_ALERT = 'CREATE_JOB_ALERT'
const CLICK_BOOK_A_CONSULTANT = 'CLICK_BOOK_A_CONSULTANT'
const useMixpanel = () => {
  return {
    track: (event: string) => {},
    EVENTS: { CREATE_JOB_ALERT: CREATE_JOB_ALERT, CLICK_BOOK_A_CONSULTANT: CLICK_BOOK_A_CONSULTANT }
  }
}
export default useMixpanel
